import UpdateDataItemRequestModelBase from '../_generated/modelBases/update-data-item-request-model-base';

export default class UpdateDataItemRequestModel extends UpdateDataItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
